import { nearbyRoads } from "@/mocks/area";

export default function AreaBelt() {
  const items = [...nearbyRoads, ...nearbyRoads];
  return (
    <section className="mt-10 sm:mt-14 md:mt-20 py-5 sm:py-7 md:py-9 border-y border-background-200 bg-background-100 overflow-hidden">
      <div className="flex items-center gap-3 sm:gap-4 md:gap-8 whitespace-nowrap marquee-track">
        {items.map((road, idx) => (
          <div key={`${road}-${idx}`} className="flex items-center gap-3 sm:gap-4 md:gap-8 text-foreground-800">
            <i className="ri-map-pin-2-line text-accent-600"></i>
            <span className="font-heading text-lg sm:text-2xl md:text-4xl font-semibold tracking-tight">
              {road}
            </span>
            <span className="text-background-400">·</span>
          </div>
        ))}
      </div>
    </section>
  );
}